import { render } from "./DisplayContent.vue?vue&type=template&id=6ccab50e"
import script from "./DisplayContent.vue?vue&type=script&lang=js"
export * from "./DisplayContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__